import React, {FunctionComponent} from 'react';

import styled from 'styled-components';

import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';

const BackgroundContainer = styled(Box)`
  ${({theme: {palette}}) => `
    background: url('./assets/pattern-x3.png'), linear-gradient(45deg, ${palette.secondary.main}, ${palette.secondary.main} 50%, ${palette.primary.main});
    background-attachment: fixed;
  `}
`;

const PageContent = styled.div`
  background: #fff;
  margin: -24px auto -7px;
  width: 800px;
  padding: 64px;
`;

export const Imprint: FunctionComponent = () => {
  return (
    <BackgroundContainer>
      <PageContent>
        <Typography variant="h1">IMPRESSUM</Typography>
        <Typography variant="h3">Angaben gemäß §5 TMG:</Typography>
        <Typography variant="h3">Anschrift</Typography>
        <Typography>Gerret Halberstadt</Typography>
        <Typography>Weißenburgstraße 39</Typography>
        <Typography>24116 Kiel</Typography>
        <Typography variant="h3">Kontakt</Typography>
        <Typography>Telefon: 0176/24386020</Typography>
        <Typography>E-Mail: halberstadtgerret@gmail.com</Typography>
        <Typography variant="h2">HAFTUNGSAUSSCHLUSS</Typography>
        <Typography variant="h3">Haftung für Inhalte</Typography>
        <Typography>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als
          Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
          allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
          jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
          hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach
          den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
          erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
          entfernen.
        </Typography>
        <Typography variant="h3">Haftung für Links</Typography>
        <Typography>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
          mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
          Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten
          ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </Typography>
        <Typography variant="h3">Urheberrecht</Typography>
        <Typography>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
          der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
          nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
          dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
          beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
          trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
          Inhalte umgehend entfernen.
        </Typography>
        <Typography variant="h3">Datenschutz</Typography>
        <Typography>
          Für die Nutzung unserer Webseite ist Die Nutzung unserer Webseite ist in der Regel ohne
          Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten
          (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit
          möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
          Zustimmung nicht an Dritte weitergegeben. Wir weisen darauf hin, dass die Datenübertragung
          im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
          lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. Der Nutzung
          von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur
          übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird
          hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich
          rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
          Spam-Mails, vor.
        </Typography>
        <br />
        <Typography variant="body2">
          Quelle: Impressumgenerator von{' '}
          <Link href="www.e-recht24.de" target="_blank" rel="noopener noreferrer">
            e-recht24.de
          </Link>
        </Typography>
      </PageContent>
    </BackgroundContainer>
  );
};

export const DataProtection: FunctionComponent = () => {
  return (
    <BackgroundContainer>
      <PageContent>
        <Typography variant="h1">DATENSCHUTZERKLÄRUNG</Typography>
        <Typography variant="h3">Allgemeiner Hinweis und Pflichtinformationen</Typography>
        <Typography variant="h3">Benennung der verantwortlichen Stelle</Typography>
        <Typography>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
        </Typography>
        <Typography>Gerret Halberstadt</Typography>
        <Typography>Weißenburgstraße 39</Typography>
        <Typography>24116 Kiel</Typography>
        <Typography>
          Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die Zwecke
          und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, Kontaktdaten o. Ä.).
        </Typography>

        <Typography variant="h3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</Typography>
        <Typography>
          Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung
          möglich. Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den
          Widerruf genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum
          Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </Typography>

        <Typography variant="h3">
          Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde
        </Typography>
        <Typography>
          Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde
          bezüglich datenschutzrechtlicher Fragen ist der Landesdatenschutzbeauftragte des
          Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet. Der folgende Link stellt
          eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit:{' '}
          <Link
            href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html
          </Link>
        </Typography>

        <Typography variant="h3">Recht auf Datenübertragbarkeit</Typography>
        <Typography>
          Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in
          Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu
          lassen. Die Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie die
          direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies
          nur, soweit es technisch machbar ist.
        </Typography>

        <Typography variant="h3">Recht auf Auskunft, Berichtigung, Sperrung, Löschung</Typography>
        <Typography>
          Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf
          unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, Herkunft der
          Daten, deren Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf
          Berichtigung, Sperrung oder Löschung dieser Daten. Diesbezüglich und auch zu weiteren
          Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im Impressum
          aufgeführten Kontaktmöglichkeiten an uns wenden.
        </Typography>

        <Typography variant="h3">SSL- bzw. TLS-Verschlüsselung</Typography>
        <Typography>
          Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an
          uns als Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung.
          Damit sind Daten, die Sie über diese Website übermitteln, für Dritte nicht mitlesbar. Sie
          erkennen eine verschlüsselte Verbindung an der „https://“ Adresszeile Ihres Browsers und
          am Schloss-Symbol in der Browserzeile.
        </Typography>

        <Typography variant="h3">Server-Log-Dateien</Typography>
        <Typography>
          In Server-Log-Dateien erhebt und speichert der Provider der Website automatisch
          Informationen, die Ihr Browser automatisch an uns übermittelt. Dies sind:
        </Typography>
        <ul>
          <li>Besuchte Seite auf unserer Domain</li>
          <li>Datum und Uhrzeit der Serveranfrage</li>
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>IP-Adresse</li>
        </ul>
        <Typography>
          Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt. Grundlage der
          Datenverarbeitung bildet Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur
          Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.
        </Typography>

        <Typography variant="h3">Registrierung auf dieser Website</Typography>
        <Typography>
          Zur Nutzung bestimmter Funktionen können Sie sich auf unserer Website registrieren. Die
          übermittelten Daten dienen ausschließlich zum Zwecke der Nutzung des jeweiligen Angebotes
          oder Dienstes.
        </Typography>
        <Typography>
          Im Falle wichtiger Änderungen, etwa aus technischen Gründen, werden alle nicht hiervon in
          Kenntnis gesetzt Nutzer gelöscht.
        </Typography>
        <Typography>
          Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt auf Grundlage Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer bereits erteilten
          Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose Mitteilung per
          E-Mail. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitung bleibt vom Widerruf
          unberührt.
        </Typography>
        <Typography>
          Wir speichern die bei der Registrierung erfassten Daten während des Zeitraums, den Sie auf
          unserer Website registriert sind. Ihren Daten werden gelöscht, sollten Sie Ihre
          Registrierung aufheben. Gesetzliche Aufbewahrungsfristen bleiben unberührt.
        </Typography>

        <Typography variant="h3">Google Web Fonts</Typography>
        <Typography>
          Unsere Website verwendet Web Fonts von Google. Anbieter ist die Google Inc., 1600
          Amphitheatre Parkway, Mountain View, CA 94043, USA.
        </Typography>
        <Typography>
          Durch den Einsatz dieser Web Fonts wird es möglich Ihnen die von uns gewünschte
          Darstellung unserer Website zu präsentieren, unabhängig davon welche Schriften Ihnen lokal
          zur Verfügung stehen. Dies erfolgt über den Abruf der Google Web Fonts von einem Server
          von Google in den USA und der damit verbundenen Weitergabe Ihre Daten an Google. Dabei
          handelt es sich um Ihre IP-Adresse und welche Seite Sie bei uns besucht haben. Der Einsatz
          von Google Web Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Als Betreiber
          dieser Website haben wir ein berechtigtes Interesse an der optimalen Darstellung und
          Übertragung unseres Webauftritts.
        </Typography>
        <Typography>
          Das Unternehmen Google ist für das us-europäische Datenschutzübereinkommen "Privacy
          Shield" zertifiziert. Dieses Datenschutzübereinkommen soll die Einhaltung des in der EU
          geltenden Datenschutzniveaus gewährleisten.
        </Typography>
        <Typography>
          Einzelheiten über Google Web Fonts finden Sie unter:{' '}
          <Link
            href="https://www.google.com/fonts#AboutPlace:about"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.google.com/fonts#AboutPlace:about
          </Link>{' '}
          und weitere Informationen in den Datenschutzbestimmungen von Google:{' '}
          <Link
            href="https://policies.google.com/privacy/partners?hl=de"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy/partners?hl=de
          </Link>
        </Typography>
        <br />
        <Typography variant="body2">
          Quelle: Datenschutz-Konfigurator von{' '}
          <Link
            href="http://www.mein-datenschutzbeauftragter.de"
            target="_blank"
            rel="noopener noreferrer"
          >
            mein-datenschutzbeauftragter.de
          </Link>
        </Typography>
      </PageContent>
    </BackgroundContainer>
  );
};
